module.exports = {
	"config": {
		"siteTitle": "Men(S)tis",
		"baseColor": "#f26d80",
		"linkPrefix": "/menstis-test"
	},
	"relativePath": "",
	"pages": [
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "_template.jsx",
				"ext": "jsx",
				"name": "_template",
				"extname": ".jsx",
				"basename": "_template.jsx",
				"dirname": "",
				"stem": "_template",
				"path": "_template.jsx"
			},
			"requirePath": "_template.jsx",
			"templatePath": "//",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "404.md",
				"ext": "md",
				"name": "404",
				"extname": ".md",
				"basename": "404.md",
				"dirname": "",
				"stem": "404",
				"path": "404.md"
			},
			"requirePath": "404.md",
			"path": "/404.html",
			"data": {
				"path": "/404.html"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "blog",
				"base": "_template.jsx",
				"ext": "jsx",
				"name": "_template",
				"extname": ".jsx",
				"basename": "_template.jsx",
				"dirname": "blog",
				"stem": "_template",
				"path": "blog\\_template.jsx"
			},
			"requirePath": "blog/_template.jsx",
			"templatePath": "/blog/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "blog\\2015-01-01-TelevisieUitzendingHetVermoeden",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "blog/2015-01-01-TelevisieUitzendingHetVermoeden",
				"stem": "index",
				"path": "blog\\2015-01-01-TelevisieUitzendingHetVermoeden\\index.md"
			},
			"requirePath": "blog/2015-01-01-TelevisieUitzendingHetVermoeden/index.md",
			"path": "/blog/2015-01-01-TelevisieUitzendingHetVermoeden/",
			"data": {
				"title": "Televisie uitzending Het Vermoeden",
				"date": "2013-04-01T00:00:00Z",
				"layout": "post",
				"attachment": null,
				"linktext": null
			}
		},
		{
			"file": {
				"root": "",
				"dir": "blog\\2015-01-02-Filmdossiers",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "blog/2015-01-02-Filmdossiers",
				"stem": "index",
				"path": "blog\\2015-01-02-Filmdossiers\\index.md"
			},
			"requirePath": "blog/2015-01-02-Filmdossiers/index.md",
			"path": "/blog/2015-01-02-Filmdossiers/",
			"data": {
				"title": "Filmdossiers",
				"date": "2013-04-01T00:00:00Z",
				"layout": "post"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "blog\\2015-01-04-Archief20Jaar",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "blog/2015-01-04-Archief20Jaar",
				"stem": "index",
				"path": "blog\\2015-01-04-Archief20Jaar\\index.md"
			},
			"requirePath": "blog/2015-01-04-Archief20Jaar/index.md",
			"path": "/blog/2015-01-04-Archief20Jaar/",
			"data": {
				"title": "Kortfilm Men(S)tis Gedachtenis",
				"date": "2013-04-01T00:00:00Z",
				"layout": "post",
				"attachment": "movie/",
				"linktext": "Bekijk het fragment"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "blog\\2015-01-04-Archief20Jaar",
				"base": "movie.md",
				"ext": "md",
				"name": "movie",
				"extname": ".md",
				"basename": "movie.md",
				"dirname": "blog/2015-01-04-Archief20Jaar",
				"stem": "movie",
				"path": "blog\\2015-01-04-Archief20Jaar\\movie.md"
			},
			"requirePath": "blog/2015-01-04-Archief20Jaar/movie.md",
			"path": "/blog/2015-01-04-Archief20Jaar/movie/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "blog\\2015-01-05-BoekGedachtenis",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "blog/2015-01-05-BoekGedachtenis",
				"stem": "index",
				"path": "blog\\2015-01-05-BoekGedachtenis\\index.md"
			},
			"requirePath": "blog/2015-01-05-BoekGedachtenis/index.md",
			"path": "/blog/2015-01-05-BoekGedachtenis/",
			"data": {
				"title": "Voorstelling boek Gedachtenis",
				"date": "2013-04-01T00:00:00Z",
				"layout": "post",
				"attachment": "Gedachtenis.pdf",
				"linktext": "Lees Kennismaking"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "blog\\2015-01-06-TrapCinematografie",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "blog/2015-01-06-TrapCinematografie",
				"stem": "index",
				"path": "blog\\2015-01-06-TrapCinematografie\\index.md"
			},
			"requirePath": "blog/2015-01-06-TrapCinematografie/index.md",
			"path": "/blog/2015-01-06-TrapCinematografie/",
			"data": {
				"title": "De trap van de cinematografie",
				"date": "2013-04-01T00:00:00Z",
				"layout": "post",
				"attachment": "Filmanalyse schema.pdf",
				"linktext": "Lees het schema voor filmanalyse en filmgesprek"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "blog\\2015-01-07-BoekAardsParadijs",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "blog/2015-01-07-BoekAardsParadijs",
				"stem": "index",
				"path": "blog\\2015-01-07-BoekAardsParadijs\\index.md"
			},
			"requirePath": "blog/2015-01-07-BoekAardsParadijs/index.md",
			"path": "/blog/2015-01-07-BoekAardsParadijs/",
			"data": {
				"title": "Voorstelling boek Het aards paradijs",
				"date": "2013-04-01T00:00:00Z",
				"layout": "post",
				"attachment": "StudieAardsParadijs.pdf",
				"linktext": "Lees kennismaking"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "blog\\2015-01-08-BergredeXIII",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "blog/2015-01-08-BergredeXIII",
				"stem": "index",
				"path": "blog\\2015-01-08-BergredeXIII\\index.md"
			},
			"requirePath": "blog/2015-01-08-BergredeXIII/index.md",
			"path": "/blog/2015-01-08-BergredeXIII/",
			"data": {
				"title": "Bergrede XIII",
				"date": "2013-04-01T00:00:00Z",
				"layout": "post",
				"attachment": "Bergrede_XIII_Blog.pdf",
				"linktext": "Lees bergrede"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "blog\\2015-01-09-InterviewBraambos",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "blog/2015-01-09-InterviewBraambos",
				"stem": "index",
				"path": "blog\\2015-01-09-InterviewBraambos\\index.md"
			},
			"requirePath": "blog/2015-01-09-InterviewBraambos/index.md",
			"path": "/blog/2015-01-09-InterviewBraambos/",
			"data": {
				"title": "Interview Braambos",
				"date": "2015-02-10T00:00:00Z",
				"layout": "post",
				"attachment": "ibr.mp3",
				"linktext": "Beluister interview"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "blog\\2015-01-10-Bibliografie",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "blog/2015-01-10-Bibliografie",
				"stem": "index",
				"path": "blog\\2015-01-10-Bibliografie\\index.md"
			},
			"requirePath": "blog/2015-01-10-Bibliografie/index.md",
			"path": "/blog/2015-01-10-Bibliografie/",
			"data": {
				"title": "Bibliografie Sylvain De Bleeckere",
				"date": "2015-05-01T22:12:03.284Z",
				"layout": "post",
				"attachment": "sdbbiblio20.pdf",
				"linktext": "Lees bibliografie"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "blog\\2017-12-27 Programakaart De Dag",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "blog/2017-12-27 Programakaart De Dag",
				"stem": "index",
				"path": "blog\\2017-12-27 Programakaart De Dag\\index.md"
			},
			"requirePath": "blog/2017-12-27 Programakaart De Dag/index.md",
			"path": "/blog/2017-12-27 Programakaart De Dag/",
			"data": {
				"title": "Programmakaart De Dag 2020",
				"date": "2017-12-27T00:00:00Z",
				"layout": "post",
				"attachment": "kaart29.pdf",
				"linktext": "Lees kaart"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "blog",
				"base": "index.js",
				"ext": "js",
				"name": "index",
				"extname": ".js",
				"basename": "index.js",
				"dirname": "blog",
				"stem": "index",
				"path": "blog\\index.js"
			},
			"requirePath": "blog/index.js",
			"path": "/blog/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "dedag",
				"base": "_template.jsx",
				"ext": "jsx",
				"name": "_template",
				"extname": ".jsx",
				"basename": "_template.jsx",
				"dirname": "dedag",
				"stem": "_template",
				"path": "dedag\\_template.jsx"
			},
			"requirePath": "dedag/_template.jsx",
			"templatePath": "/dedag/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "dedag",
				"base": "geschiedenis.md",
				"ext": "md",
				"name": "geschiedenis",
				"extname": ".md",
				"basename": "geschiedenis.md",
				"dirname": "dedag",
				"stem": "geschiedenis",
				"path": "dedag\\geschiedenis.md"
			},
			"requirePath": "dedag/geschiedenis.md",
			"path": "/dedag/geschiedenis/",
			"data": {
				"title": "Geschiedenis"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "dedag",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "dedag",
				"stem": "index",
				"path": "dedag\\index.md"
			},
			"requirePath": "dedag/index.md",
			"path": "/dedag/",
			"data": {
				"title": "Concept"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "dedag",
				"base": "inschrijving.md",
				"ext": "md",
				"name": "inschrijving",
				"extname": ".md",
				"basename": "inschrijving.md",
				"dirname": "dedag",
				"stem": "inschrijving",
				"path": "dedag\\inschrijving.md"
			},
			"requirePath": "dedag/inschrijving.md",
			"path": "/dedag/inschrijving/",
			"data": {
				"title": "Inschrijving"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "dedag",
				"base": "locatie-contact.md",
				"ext": "md",
				"name": "locatie-contact",
				"extname": ".md",
				"basename": "locatie-contact.md",
				"dirname": "dedag",
				"stem": "locatie-contact",
				"path": "dedag\\locatie-contact.md"
			},
			"requirePath": "dedag/locatie-contact.md",
			"path": "/dedag/locatie-contact/",
			"data": {
				"title": "Locatie & Contact"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "dedag\\programma",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "dedag/programma",
				"stem": "index",
				"path": "dedag\\programma\\index.md"
			},
			"requirePath": "dedag/programma/index.md",
			"path": "/dedag/programma/",
			"data": {
				"title": "Programma 2020"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "dedag",
				"base": "toeschouwers.md",
				"ext": "md",
				"name": "toeschouwers",
				"extname": ".md",
				"basename": "toeschouwers.md",
				"dirname": "dedag",
				"stem": "toeschouwers",
				"path": "dedag\\toeschouwers.md"
			},
			"requirePath": "dedag/toeschouwers.md",
			"path": "/dedag/toeschouwers/",
			"data": {
				"title": "Toeschouwers"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "film-focus",
				"base": "_template.jsx",
				"ext": "jsx",
				"name": "_template",
				"extname": ".jsx",
				"basename": "_template.jsx",
				"dirname": "film-focus",
				"stem": "_template",
				"path": "film-focus\\_template.jsx"
			},
			"requirePath": "film-focus/_template.jsx",
			"templatePath": "/film-focus/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "film-focus\\agora",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "film-focus/agora",
				"stem": "index",
				"path": "film-focus\\agora\\index.md"
			},
			"requirePath": "film-focus/agora/index.md",
			"path": "/film-focus/agora/",
			"data": {
				"title": "Agora"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "film-focus\\andreiroublev",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "film-focus/andreiroublev",
				"stem": "index",
				"path": "film-focus\\andreiroublev\\index.md"
			},
			"requirePath": "film-focus/andreiroublev/index.md",
			"path": "/film-focus/andreiroublev/",
			"data": {
				"title": "Andrei Roublev"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "film-focus\\benx",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "film-focus/benx",
				"stem": "index",
				"path": "film-focus\\benx\\index.md"
			},
			"requirePath": "film-focus/benx/index.md",
			"path": "/film-focus/benx/",
			"data": {
				"title": "BenX"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "film-focus\\birthofanation",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "film-focus/birthofanation",
				"stem": "index",
				"path": "film-focus\\birthofanation\\index.md"
			},
			"requirePath": "film-focus/birthofanation/index.md",
			"path": "/film-focus/birthofanation/",
			"data": {
				"title": "The Birth of a Nation"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "film-focus\\comeandsee",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "film-focus/comeandsee",
				"stem": "index",
				"path": "film-focus\\comeandsee\\index.md"
			},
			"requirePath": "film-focus/comeandsee/index.md",
			"path": "/film-focus/comeandsee/",
			"data": {
				"title": "Come and See"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "film-focus\\damien",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "film-focus/damien",
				"stem": "index",
				"path": "film-focus\\damien\\index.md"
			},
			"requirePath": "film-focus/damien/index.md",
			"path": "/film-focus/damien/",
			"data": {
				"title": "Father Damien"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "film-focus\\darkesthour",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "film-focus/darkesthour",
				"stem": "index",
				"path": "film-focus\\darkesthour\\index.md"
			},
			"requirePath": "film-focus/darkesthour/index.md",
			"path": "/film-focus/darkesthour/",
			"data": {
				"title": "Darkest Hour"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "film-focus\\Dekalog",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "film-focus/Dekalog",
				"stem": "index",
				"path": "film-focus\\Dekalog\\index.md"
			},
			"requirePath": "film-focus/Dekalog/index.md",
			"path": "/film-focus/Dekalog/",
			"data": {
				"title": "Dekalog"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "film-focus\\desterre",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "film-focus/desterre",
				"stem": "index",
				"path": "film-focus\\desterre\\index.md"
			},
			"requirePath": "film-focus/desterre/index.md",
			"path": "/film-focus/desterre/",
			"data": {
				"title": "En waar de sterre bleef stille staan"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "film-focus\\dolls",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "film-focus/dolls",
				"stem": "index",
				"path": "film-focus\\dolls\\index.md"
			},
			"requirePath": "film-focus/dolls/index.md",
			"path": "/film-focus/dolls/",
			"data": {
				"title": "Dolls"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "film-focus\\elsoldelmembrillo",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "film-focus/elsoldelmembrillo",
				"stem": "index",
				"path": "film-focus\\elsoldelmembrillo\\index.md"
			},
			"requirePath": "film-focus/elsoldelmembrillo/index.md",
			"path": "/film-focus/elsoldelmembrillo/",
			"data": {
				"title": "El sol del membrillo"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "film-focus\\goddess",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "film-focus/goddess",
				"stem": "index",
				"path": "film-focus\\goddess\\index.md"
			},
			"requirePath": "film-focus/goddess/index.md",
			"path": "/film-focus/goddess/",
			"data": {
				"title": "Goddess of 1967"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "film-focus\\hommes",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "film-focus/hommes",
				"stem": "index",
				"path": "film-focus\\hommes\\index.md"
			},
			"requirePath": "film-focus/hommes/index.md",
			"path": "/film-focus/hommes/",
			"data": {
				"title": "Des hommes et des dieux"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "film-focus\\ida",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "film-focus/ida",
				"stem": "index",
				"path": "film-focus\\ida\\index.md"
			},
			"requirePath": "film-focus/ida/index.md",
			"path": "/film-focus/ida/",
			"data": {
				"title": "Ida"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "film-focus",
				"base": "index.jsx",
				"ext": "jsx",
				"name": "index",
				"extname": ".jsx",
				"basename": "index.jsx",
				"dirname": "film-focus",
				"stem": "index",
				"path": "film-focus\\index.jsx"
			},
			"requirePath": "film-focus/index.jsx",
			"path": "/film-focus/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "film-focus\\innocentes",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "film-focus/innocentes",
				"stem": "index",
				"path": "film-focus\\innocentes\\index.md"
			},
			"requirePath": "film-focus/innocentes/index.md",
			"path": "/film-focus/innocentes/",
			"data": {
				"title": "Les Innocentes"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "film-focus\\intothewild",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "film-focus/intothewild",
				"stem": "index",
				"path": "film-focus\\intothewild\\index.md"
			},
			"requirePath": "film-focus/intothewild/index.md",
			"path": "/film-focus/intothewild/",
			"data": {
				"title": "Into the Wild"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "film-focus\\iris",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "film-focus/iris",
				"stem": "index",
				"path": "film-focus\\iris\\index.md"
			},
			"requirePath": "film-focus/iris/index.md",
			"path": "/film-focus/iris/",
			"data": {
				"title": "Iris"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "film-focus\\italiensk",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "film-focus/italiensk",
				"stem": "index",
				"path": "film-focus\\italiensk\\index.md"
			},
			"requirePath": "film-focus/italiensk/index.md",
			"path": "/film-focus/italiensk/",
			"data": {
				"title": "Italiensk for Begyndere"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "film-focus\\kain",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "film-focus/kain",
				"stem": "index",
				"path": "film-focus\\kain\\index.md"
			},
			"requirePath": "film-focus/kain/index.md",
			"path": "/film-focus/kain/",
			"data": {
				"title": "Kaïn"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "film-focus\\marieheurtin",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "film-focus/marieheurtin",
				"stem": "index",
				"path": "film-focus\\marieheurtin\\index.md"
			},
			"requirePath": "film-focus/marieheurtin/index.md",
			"path": "/film-focus/marieheurtin/",
			"data": {
				"title": "Marie Heurtin"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "film-focus\\millcross",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "film-focus/millcross",
				"stem": "index",
				"path": "film-focus\\millcross\\index.md"
			},
			"requirePath": "film-focus/millcross/index.md",
			"path": "/film-focus/millcross/",
			"data": {
				"title": "The Mill & the Cross"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "film-focus\\mrturner",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "film-focus/mrturner",
				"stem": "index",
				"path": "film-focus\\mrturner\\index.md"
			},
			"requirePath": "film-focus/mrturner/index.md",
			"path": "/film-focus/mrturner/",
			"data": {
				"title": "Mr. Turner"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "film-focus\\nativity",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "film-focus/nativity",
				"stem": "index",
				"path": "film-focus\\nativity\\index.md"
			},
			"requirePath": "film-focus/nativity/index.md",
			"path": "/film-focus/nativity/",
			"data": {
				"title": "The Nativity Story"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "film-focus\\newworld",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "film-focus/newworld",
				"stem": "index",
				"path": "film-focus\\newworld\\index.md"
			},
			"requirePath": "film-focus/newworld/index.md",
			"path": "/film-focus/newworld/",
			"data": {
				"title": "The New World"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "film-focus\\pilgrimage",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "film-focus/pilgrimage",
				"stem": "index",
				"path": "film-focus\\pilgrimage\\index.md"
			},
			"requirePath": "film-focus/pilgrimage/index.md",
			"path": "/film-focus/pilgrimage/",
			"data": {
				"title": "PilgrImage"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "film-focus\\priere",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "film-focus/priere",
				"stem": "index",
				"path": "film-focus\\priere\\index.md"
			},
			"requirePath": "film-focus/priere/index.md",
			"path": "/film-focus/priere/",
			"data": {
				"title": "La prière"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "film-focus\\resurrection",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "film-focus/resurrection",
				"stem": "index",
				"path": "film-focus\\resurrection\\index.md"
			},
			"requirePath": "film-focus/resurrection/index.md",
			"path": "/film-focus/resurrection/",
			"data": {
				"title": "Resurrection"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "film-focus\\samara",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "film-focus/samara",
				"stem": "index",
				"path": "film-focus\\samara\\index.md"
			},
			"requirePath": "film-focus/samara/index.md",
			"path": "/film-focus/samara/",
			"data": {
				"title": "Samsara"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "film-focus\\silence",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "film-focus/silence",
				"stem": "index",
				"path": "film-focus\\silence\\index.md"
			},
			"requirePath": "film-focus/silence/index.md",
			"path": "/film-focus/silence/",
			"data": {
				"title": "Into Great Silence"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "film-focus\\sonofsaul",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "film-focus/sonofsaul",
				"stem": "index",
				"path": "film-focus\\sonofsaul\\index.md"
			},
			"requirePath": "film-focus/sonofsaul/index.md",
			"path": "/film-focus/sonofsaul/",
			"data": {
				"title": "Son of Saul"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "film-focus\\spirited",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "film-focus/spirited",
				"stem": "index",
				"path": "film-focus\\spirited\\index.md"
			},
			"requirePath": "film-focus/spirited/index.md",
			"path": "/film-focus/spirited/",
			"data": {
				"title": "Spirited Away"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "index.jsx",
				"ext": "jsx",
				"name": "index",
				"extname": ".jsx",
				"basename": "index.jsx",
				"dirname": "",
				"stem": "index",
				"path": "index.jsx"
			},
			"requirePath": "index.jsx",
			"path": "/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "missie",
				"base": "_template.jsx",
				"ext": "jsx",
				"name": "_template",
				"extname": ".jsx",
				"basename": "_template.jsx",
				"dirname": "missie",
				"stem": "_template",
				"path": "missie\\_template.jsx"
			},
			"requirePath": "missie/_template.jsx",
			"templatePath": "/missie/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "missie",
				"base": "index_old.html",
				"ext": "html",
				"name": "index_old",
				"extname": ".html",
				"basename": "index_old.html",
				"dirname": "missie",
				"stem": "index_old",
				"path": "missie\\index_old.html"
			},
			"requirePath": "missie/index_old.html",
			"path": "/missie/index_old/",
			"data": {
				"body": "<!DOCTYPE HTML PUBLIC \"-//W3C//DTD HTML 4.0 Transitional//EN\">\r\n<html><!-- InstanceBegin template=\"/Templates/missie.dwt\" codeOutsideHTMLIsLocked=\"false\" -->\r\n<head>\r\n<meta http-equiv=\"Content-Type\" content=\"text/html; charset=iso-8859-1\">\r\n<meta http-equiv=\"imagetoolbar\" content=\"no\">\r\n<!-- InstanceBeginEditable name=\"titel\" -->\r\n<title>Missie statement Men(s)tis vzw</title>\r\n<!-- InstanceEndEditable -->\r\n<link href=\"/style/basic.css\" rel=\"stylesheet\" type=\"text/css\" media=\"all\">\r\n<link rel=\"icon\" type=\"image/gif\" href=\"/favicon.gif\">\r\n</head>\r\n<body bgcolor=\"#FFFFF4\" text=\"#7F7D82\" link=\"#7366EE\" vlink=\"#8388FF\" alink=\"#F78A6A\">\r\n<div align=\"center\">\r\n<center>\r\n\r\n<table border=\"0\" cellpadding=\"10\" cellspacing=\"0\" width=\"80%\">\r\n<tr>\r\n\t<td><a href=\"index.html\"><img border=\"0\" src=\"../statement.jpg\" width=\"60\" height=\"30\" alt=\"Missie\"></a></td>\r\n\t<td><a href=\"../blog/index.html\"><img border=\"0\" src=\"../etalage.jpg\" width=\"60\" height=\"30\" alt=\"Blog\"></a></td>\r\n\t<td><a href=\"../dedag/index.html\"><img border=\"0\" src=\"../De%20Dag.jpg\" width=\"30\" height=\"45\" alt=\"De Dag van de Religieuze Film\"></a></td>\r\n\t<td><a href=\"../film/index.html\"><img border=\"0\" src=\"../FilmFocus.jpg\" width=\"30\" height=\"45\" alt=\"FilmFocus\"></a></td>\r\n\t<td><a href=\"../producties/index.html\"><img border=\"0\" src=\"../producties.jpg\" width=\"60\" height=\"30\" alt=\"Producties\"></a></td>\r\n    <td><a href=\"../uitgeverij/index.html\"><img border=\"0\" src=\"../uitgeverij.jpg\" width=\"60\" height=\"30\" alt=\"Uitgeverij\"></a></td>\r\n</tr>\r\n\r\n</table>\r\n<table border=\"0\" cellpadding=\"4\" cellspacing=\"0\" width=\"90%\">\r\n    <tr>\r\n        <td width=\"160\" valign=\"top\" rowspan=\"2\" bgcolor=\"#FCF9FF\">\r\n\t\t\t\t       \r\n\t\t<!-- InstanceBeginEditable name=\"menueinde\" -->\r\n\t\t\t<h2>Men(S)tis vzw</h2>\r\n\t        <p><a href=\"#HOM\"><b>Mens</b></a><br></p>\r\n\t        <p><a href=\"#GEE\"><b>Geest</b></a><br></p>\r\n\t        <p><a href=\"#HET\"><b>Leven</b></a><br></p>\r\n\t        \r\n\t        <p><a href=\"#STI\"><b>Stichtende leden</b></a><br></p><!-- InstanceEndEditable -->\r\n\t\t</td>\r\n        <td rowspan=\"2\">&nbsp;</td>\r\n        <td valign=\"bottom\" nowrap bgcolor=\"#400030\"><font color=\"#FFFFF4\"><h2>\r\n\t\t<!-- InstanceBeginEditable name=\"subtitel\" -->Missie\r\n\t\t<!-- InstanceEndEditable -->\r\n\t\t</h2>\r\n\t\t<h2>\r\n\t\t  <!-- InstanceBeginEditable name=\"subtitel2\" --><!-- InstanceEndEditable -->\r\n\t\t</h2></font>\r\n        </td>\r\n    </tr>\r\n \t<tr>\r\n\t\t<td valign=\"top\" bgcolor=\"#FCF9FF\">\r\n             <!-- InstanceBeginEditable name=\"Inhoud\" -->\r\n\t\t\t<p>De missie van de vereniging zonder winstgevend doel, <strong class=\"menstis\">Men(S)tis, </strong>rust op </strong><span class=\"opvallend\"><strong>de waarden 'mens, geest en leven'</strong></span>. </p>\r\n\t\t\t<p><strong>Het eerste element, </strong><span class=\"opvallend\"><strong>de mens, </strong></span>is aanwezig in de naam die leest als 'mens, menstis'.<strong class=\"menstis\">  Men(S)tis vzw</strong> <strong>wil het mysterie van de menswording</strong> blijven huldigen en  exploreren.</p>\r\n\t\t\t<p><strong>Het tweede element </strong> van  'mens, menstis', is  <strong>het Latijnse woord mens voor </strong><span class=\"opvallend\"><strong>geest</strong></span>.  Die betekenis blijft immers goed leesbaar in de woorden 'mentaal, mentaliteit'   en het Engelse 'mind'.   <strong class=\"menstis\">Men(S)tis   </strong><strong>werkt vanuit  de mentale rijkdom van de mens.</strong> In en door de mens stroomt er  een innerlijk kapitaal aan gedachten, gevoelens en beelden. Het hoort bij de Homo  sapiens als de bladeren aan de boom, maar... ze zijn diens eigendom niet. De  Latijnse genitief &mdash; <em>menstis</em> &mdash; signaleert dat de mens verbonden  is met <strong>de wonderlijke en complexe wereld van de geest</strong>, een wereld waarin  het fenomeen mens zijn nest heeft, een wereld waarin hij thuis is en woont,  maar die hij niet als zijn volle eigendom bezit of beheerst.             </p><p><center><a name=\"GIB\"></a><img src=\"GIB.jpg\" width=200 height=200> </center></p>\r\n<p><strong>Het derde element</strong> van de missie, is <strong>het fenomeen van </strong><span class=\"opvallend\"><strong>het leven</strong></span>.</strong> Daarvan is het beeldlogo het zichtbare teken. Het beeld, een creatie van Nelly Claeys in opdracht van de vereniging, toont in close-up een ginkgoblad op een alizarine rode achtergrond. Het blad vertegenwoordigt  de oudste  boom, de <strong>ginkgo biloba</strong>. Hij is de  echte levensboom van de planeet aarde. <strong class=\"menstis\">Men(S)tis  vzw</strong> participeert hiermee aan een kunsttraditie die het ginkgoblad als  <strong>het levende beeld ziet van de heilige waarde van het leven</strong>. De Duitse dichter Goethe bezong het ginkgoblad;  het hedendaagse Britse kunstenaarsduo Gilbert &amp; George nam het blad als leidmotief voor een reeks van werken.</p>\r\n<p><strong class=\"menstis\">Men(S)tis  vzw</strong> schept met ieder initiatief  een re&euml;le en mentale ruimte die verschijnt als een <strong>bescheiden, tijdelijke en  vruchtbare zone van zin</strong>, een oord van levensbeschouwing. <strong class=\"menstis\">Men(S)tis vzw</strong> wil hiermee bijdragen tot de ontwikkeling van  <strong>het  beeldend denken</strong> en tot <strong>het onderzoek naar de  religiositeit, eigen aan de zich ontwikkelende audiovisuele cultuur</strong>. </p>\r\n<p>De vereniging heeft ook een <strong>eigen website </strong>en<strong> een Facebook-profiel</strong>.</p>\r\n<p><a name=\"STI\"></a>De</strong><span class=\"opvallend\"> <strong>stichtende leden</strong></span> </strong>zijn: Sylvain De Bleeckere  (1950), Felix Rijcken (1929), Nicole De Bleeckere-Van de Kerckhove (1951-1996),  Gie Dandois (1955-1997). De <strong>huidige </strong>bestuursleden  zijn: Sylvain De Bleeckere (voorzitter), Felix Rijcken (ondervoorzitter), Samuel   De Bleeckere (secretaris-boekhouder).</p>\r\n             <!-- InstanceEndEditable -->\r\n\t\t</td>\r\n     </tr>\r\n</table>\r\n</center>\r\n</div>\r\n</body>\r\n<!-- InstanceEnd --></html>\r\n"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "missie",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "missie",
				"stem": "index",
				"path": "missie\\index.md"
			},
			"requirePath": "missie/index.md",
			"path": "/missie/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "producties",
				"base": "_template.jsx",
				"ext": "jsx",
				"name": "_template",
				"extname": ".jsx",
				"basename": "_template.jsx",
				"dirname": "producties",
				"stem": "_template",
				"path": "producties\\_template.jsx"
			},
			"requirePath": "producties/_template.jsx",
			"templatePath": "/producties/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "producties\\Agora",
				"base": "AgoraMovies.jsx",
				"ext": "jsx",
				"name": "AgoraMovies",
				"extname": ".jsx",
				"basename": "AgoraMovies.jsx",
				"dirname": "producties/Agora",
				"stem": "AgoraMovies",
				"path": "producties\\Agora\\AgoraMovies.jsx"
			},
			"requirePath": "producties/Agora/AgoraMovies.jsx",
			"path": "/producties/Agora/AgoraMovies/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "producties\\Agora",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "producties/Agora",
				"stem": "index",
				"path": "producties\\Agora\\index.md"
			},
			"requirePath": "producties/Agora/index.md",
			"path": "/producties/Agora/",
			"data": {
				"title": "AGORA: KERKGEBOUW - WEEFSEL VAN ZINGEVING",
				"order": 1
			}
		},
		{
			"file": {
				"root": "",
				"dir": "producties\\ClairObscur",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "producties/ClairObscur",
				"stem": "index",
				"path": "producties\\ClairObscur\\index.md"
			},
			"requirePath": "producties/ClairObscur/index.md",
			"path": "/producties/ClairObscur/",
			"data": {
				"title": "Clair - Obscur",
				"order": 3
			}
		},
		{
			"file": {
				"root": "",
				"dir": "producties\\DeGeleMadonna",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "producties/DeGeleMadonna",
				"stem": "index",
				"path": "producties\\DeGeleMadonna\\index.md"
			},
			"requirePath": "producties/DeGeleMadonna/index.md",
			"path": "/producties/DeGeleMadonna/",
			"data": {
				"title": "De Madonna van de Tederheid",
				"order": 4
			}
		},
		{
			"file": {
				"root": "",
				"dir": "producties",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "producties",
				"stem": "index",
				"path": "producties\\index.md"
			},
			"requirePath": "producties/index.md",
			"path": "/producties/",
			"data": {
				"title": "Producties"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "producties\\Jute",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "producties/Jute",
				"stem": "index",
				"path": "producties\\Jute\\index.md"
			},
			"requirePath": "producties/Jute/index.md",
			"path": "/producties/Jute/",
			"data": {
				"title": "Jute",
				"order": 2
			}
		},
		{
			"file": {
				"root": "",
				"dir": "webshop",
				"base": "_template.jsx",
				"ext": "jsx",
				"name": "_template",
				"extname": ".jsx",
				"basename": "_template.jsx",
				"dirname": "webshop",
				"stem": "_template",
				"path": "webshop\\_template.jsx"
			},
			"requirePath": "webshop/_template.jsx",
			"templatePath": "/webshop/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "webshop\\AanDeTafel",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "webshop/AanDeTafel",
				"stem": "index",
				"path": "webshop\\AanDeTafel\\index.md"
			},
			"requirePath": "webshop/AanDeTafel/index.md",
			"path": "/webshop/AanDeTafel/",
			"data": {
				"title": "Aan de tafel van het verborgen atelier"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "webshop\\AardsParadijs",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "webshop/AardsParadijs",
				"stem": "index",
				"path": "webshop\\AardsParadijs\\index.md"
			},
			"requirePath": "webshop/AardsParadijs/index.md",
			"path": "/webshop/AardsParadijs/",
			"data": {
				"title": "Het aards paradijs als zinnebeeld"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "webshop\\Beeldgebed",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "webshop/Beeldgebed",
				"stem": "index",
				"path": "webshop\\Beeldgebed\\index.md"
			},
			"requirePath": "webshop/Beeldgebed/index.md",
			"path": "/webshop/Beeldgebed/",
			"data": {
				"title": "Beeldgebed"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "webshop",
				"base": "index.js",
				"ext": "js",
				"name": "index",
				"extname": ".js",
				"basename": "index.js",
				"dirname": "webshop",
				"stem": "index",
				"path": "webshop\\index.js"
			},
			"requirePath": "webshop/index.js",
			"path": "/webshop/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "webshop\\Kerkgebouw",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "webshop/Kerkgebouw",
				"stem": "index",
				"path": "webshop\\Kerkgebouw\\index.md"
			},
			"requirePath": "webshop/Kerkgebouw/index.md",
			"path": "/webshop/Kerkgebouw/",
			"data": {
				"title": "Meerstemmig kerkgebouw"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "webshop\\Land",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "webshop/Land",
				"stem": "index",
				"path": "webshop\\Land\\index.md"
			},
			"requirePath": "webshop/Land/index.md",
			"path": "/webshop/Land/",
			"data": {
				"title": "Het Beloofde Land"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "webshop\\LerenLevenMetBeelden",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "webshop/LerenLevenMetBeelden",
				"stem": "index",
				"path": "webshop\\LerenLevenMetBeelden\\index.md"
			},
			"requirePath": "webshop/LerenLevenMetBeelden/index.md",
			"path": "/webshop/LerenLevenMetBeelden/",
			"data": {
				"title": "Leren Leven Met Beelden"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "webshop\\Levensbeschouwing",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "webshop/Levensbeschouwing",
				"stem": "index",
				"path": "webshop\\Levensbeschouwing\\index.md"
			},
			"requirePath": "webshop/Levensbeschouwing/index.md",
			"path": "/webshop/Levensbeschouwing/",
			"data": {
				"title": "Levensbeschouwing democratisch belicht"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "webshop\\MethodeBoek",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "webshop/MethodeBoek",
				"stem": "index",
				"path": "webshop\\MethodeBoek\\index.md"
			},
			"requirePath": "webshop/MethodeBoek/index.md",
			"path": "/webshop/MethodeBoek/",
			"data": {
				"title": "Methode Boek"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "webshop\\MethodeCD",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "webshop/MethodeCD",
				"stem": "index",
				"path": "webshop\\MethodeCD\\index.md"
			},
			"requirePath": "webshop/MethodeCD/index.md",
			"path": "/webshop/MethodeCD/",
			"data": {
				"title": "Methode CD"
			}
		}
	]
}


//////////////////
// WEBPACK FOOTER
// ../config.toml
// module id = 404
// module chunks = 0